<template>
  <div class="landing-widget">
    <vue-scroll @handle-scroll="handlePostScroll" ref="vs" :ops="{
      scrollPanel: {
        initialScrollY: false,
        initialScrollX: false,
        scrollingX: false,
        scrollingY: true,
        speed: 300,
        easing: undefined,
        verticalNativeBarPos: 'right',
      },
      bar: {
        showDelay: 500,
        onlyShowBarOnScroll: true,
        keepShow: false,
        background: '#fff',
        opacity: 1,
        hoverStyle: false,
        specifyBorderRadius: false,
        minSize: 0,
        size: '10px',
        disable: false,
      },
    }">
      <div class="screen-section section_1">
        <div class="section_1_bg active"></div>
        <div class="colrner-1-object"></div>
        <div class="colrner-2-object"></div>
        <!-- <div class="blue-pill-object">
          <img src="@/assets/landing/blue-pill.png" />
        </div> -->
        <div class="toroid-yellow-object">
          <img src="@/assets/landing/toroid-yellow.png" />
        </div>
        <div class="navigation-widget">
          <div class="nav-brand">
            <img @click="goto('/')" src="../assets/icons/log2.svg" width="156px" />
          </div>

          <div class="nav-options">
            <button class="sign_in_btn" @click="login">Login</button>
            <button class="register_btn" @click="signUp">
              <span>JOIN US</span> <img src="@/assets/icons/long_right.svg" />
            </button>
          </div>
        </div>
        <div class="section-1-content">
          <div class="slide-widget">
            <div class="sphere-object">
              <img src="@/assets/landing/Sphere-White-Matte.png" />
            </div>
            <div class="slide-content-widget">
              <h1>{{ selected_slide.title || "Meritios" }},</h1>
              <transition name="slide-fade">
                <p v-if="selected_slide" v-html="selected_slide.content"></p>
              </transition>
              <div class="slide-dots">
                <template v-for="(item, index) in slide_content">
                  <div :key="index" class="slide-dot" :class="{ active: index == active_slide }"></div>
                </template>
              </div>
            </div>
            <div class="section-options">
              <button class="btn-get-started" @click="login">
                Get Started
              </button>
              <!-- <button class="btn-learn-more">Learn More</button> -->
            </div>
          </div>
          <div class="section-1-image-widget">
            <img class="student" src="@/assets/landing/Saly.png" alt="" />
            <img class="orange-box-object" src="@/assets/landing/orange-box.png" />
            <img src="@/assets/landing/toroid-purple.png" class="toroid-purple" alt="" />
          </div>
        </div>
        <div class="section-go-next-widget">
          <button class="how-it-works" @click="nextPage('.section_2')">
            How it works <img src="@/assets/icons/allow-blue-down.svg" />
          </button>
        </div>
      </div>
      <div class="screen-section section_2">
        <div class="section_2_bg"></div>
        <div class="section-content">
          <h1 class="section-title">
            <b>Meritios</b> for

            <span>
              <dropdown-menu v-model="show_dropdown_1" :right="true" :hover="false" :interactive="true">
                <button class="btn-dropdown">
                  <b>Schools</b>
                  <img src="@/assets/admin-icon/white-caret-down.svg" />
                </button>
                <div slot="dropdown" class="dropdown-widget">
                  <a class="dropdown-item" :class="{ active: active_section == 2 }"
                    @click.prevent="nextPage('.section_2')">Schools</a>
                  <a class="dropdown-item" @click.prevent="nextPage('.section_3')">Students</a>
                  <a class="dropdown-item" @click.prevent="nextPage('.section_4')">Companies</a>
                </div>
              </dropdown-menu>
            </span>
          </h1>
          <div class="crm-summury-widget">
            <div class="crm-navigation">
              <img class="toroid-yellow" src="@/assets/landing/toroid-yellow.png" />
              <ul>
                <template v-for="(item, index) in crm_routes">
                  <li :key="index" v-if="item.enabled" :class="{ active: item.active }" @click="selectCrmRoute(item)">
                    <img class="icon" :src="require('@/assets/admin-icon/' + item.icon)" />
                    <img class="icon-active" :src="require('@/assets/admin-icon/' + item.icon_active)" />
                    <span class="menu-text">{{ item.label }}</span>
                  </li>
                </template>
              </ul>
            </div>
            <div class="crm-preview">
              <img v-if="selected_crm_route.preview" :src="selected_crm_route.preview" />
            </div>
          </div>
        </div>
        <div class="section-go-next-widget">
          <button class="how-it-works" @click="nextPage('.section_3')">
            View more <img src="@/assets/icons/allow-blue-down.svg" />
          </button>
        </div>
      </div>
      <div class="screen-section section_3">
        <div class="section_3_bg"></div>
        <div class="section-content">
          <h1 class="section-title">
            <b>Meritios</b> for
            <span>
              <dropdown-menu v-model="show_dropdown_2" :right="true" :hover="false" :interactive="true">
                <button class="btn-dropdown">
                  <b>Students</b>
                  <img src="@/assets/admin-icon/white-caret-down.svg" />
                </button>
                <div slot="dropdown" class="dropdown-widget">
                  <a class="dropdown-item" @click.prevent="nextPage('.section_2')">Schools</a>
                  <a class="dropdown-item" :class="{ active: active_section == 3 }"
                    @click.prevent="nextPage('.section_3')">Students</a>
                  <a class="dropdown-item" @click.prevent="nextPage('.section_4')">Companies</a>
                </div>
              </dropdown-menu>
            </span>
          </h1>
          <div class="crm-summury-widget">
            <div class="crm-navigation">
              <ul>
                <template v-for="(item, index) in students_routes">
                  <li :key="index" v-if="item.enabled" :class="{ active: item.active }" @click="selectStudentRoute(item)">
                    <img class="icon" :src="require('@/assets/admin-icon/student/' + item.icon)" />
                    <img class="icon-active" :src="require('@/assets/admin-icon/student/' +
                      item.icon_active)
                      " />
                    <span class="menu-text">{{ item.label }}</span>
                  </li>
                </template>
              </ul>
            </div>
            <div class="crm-preview">
              <!-- <img
                class="pill-object"
                src="@/assets/landing/full-Pill-Blue-Glossy.png"
              /> -->
              <img v-if="selected_students_route.preview" class="preview-image" :src="selected_students_route.preview" />
            </div>
          </div>
        </div>
        <div class="section-go-next-widget">
          <button class="how-it-works" @click="nextPage('.section_4')">
            View more <img src="@/assets/icons/allow-blue-down.svg" />
          </button>
        </div>
      </div>
      <div class="screen-section section_4">
        <div class="section_4_bg"></div>
        <div class="section-content">
          <h1 class="section-title">
            <b>Meritios</b> for
            <span>
              <dropdown-menu v-model="show_dropdown_3" :right="true" :hover="false" :interactive="true">
                <button class="btn-dropdown">
                  <b>Companies</b>
                  <img src="@/assets/admin-icon/white-caret-down.svg" />
                </button>
                <div slot="dropdown" class="dropdown-widget">
                  <a class="dropdown-item" @click.prevent="nextPage('.section_2')">Schools</a>
                  <a class="dropdown-item" @click.prevent="nextPage('.section_3')">Students</a>
                  <a class="dropdown-item" :class="{ active: active_section == 4 }"
                    @click.prevent="nextPage('.section_4')">Companies</a>
                </div>
              </dropdown-menu>
            </span>
          </h1>
          <div class="crm-summury-widget">
            <div class="crm-navigation">
              <img class="orange-object" src="@/assets/landing/orange-box.png" />
              <ul>
                <template v-for="(item, index) in companies_routes">
                  <li :key="index" v-if="item.enabled" :class="{ active: item.active }"
                    @click="selectCompanyRoutes(item)">
                    <img class="icon" :src="require('@/assets/admin-icon/company/' + item.icon)" />
                    <img class="icon-active" :src="require('@/assets/admin-icon/company/' +
                      item.icon_active)
                      " />
                    <span class="menu-text">{{ item.label }}</span>
                  </li>
                </template>
              </ul>
            </div>
            <div class="crm-preview">
              <img class="preview-image" v-if="selected_companies_route.preview"
                :src="selected_companies_route.preview" />
            </div>
          </div>
        </div>
        <div class="section-go-next-widget">
          <button class="how-it-works" @click="nextPage('.section_5')">
            View more <img src="@/assets/icons/allow-blue-down.svg" />
          </button>
        </div>
      </div>

      <div class="screen-section section_5">
        <div class="section_5_bg"></div>
        <div class="contacts-widget">
          <div class="header">
            <h2>Get started with MERITIOS today!</h2>
            <p>Fill in below and we contact you for a demo or next step.</p>
          </div>
          <div class="body">
            <div class="form-widget">
              <img class="cicle-image" src="@/assets/landing/big-Sphere-White-Matte.png" />

              <input type="text" placeholder="Company" v-model="contact.company" />
              <input type="text" placeholder="Email" v-model="contact.mail_from" />
              <input type="text" placeholder="Phone" v-model="contact.phone" />
              <c-button :loading="is_contact_loading" class="btn-submit" @click="sendContactMail">
                Contact me
              </c-button>
            </div>
          </div>
        </div>

        <div class="footer-widget">
          <button @click="nextPage('.section_1')" class="btn-back">
            Go to Top
          </button>
          <img src="@/assets/icons/log2.svg" />
        </div>
      </div>

      <div class="screen-section section_6" v-if="false">
        <div class="section_6_bg"></div>
        <div class="section-content">
          <h1 class="section-title">What they think about <b>MERITIOS </b></h1>
          <div class="crm-summury-widget">
            <img class="cicle-image" src="@/assets/landing/big-Sphere-White-Matte.png" />

            <div class="item-body">
              <p>
                <img class="image-quote" src="@/assets/admin-icon/quote.svg" />
                Meritios is unique - first tool that combines all core processes
                in a school business with a student to Company Network.
              </p>
              <div class="info-content">
                <img class="profile" src="@/assets/jonas.jpg" />
                <h3 class="names">Jonas Luthander</h3>
              </div>
            </div>

            <div class="item-body">
              <p>
                <img class="image-quote" src="@/assets/admin-icon/quote.svg" />
                This is a perfect tool for Schools & Companies as well as
                students around the globe with professional user centered
                features.
              </p>
              <div class="info-content">
                <img class="profile" src="@/assets/vegard.jpg" />
                <h3 class="names">Vegard Jensvoll</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
    <cookieLaw v-if="show_cookie_law" @decline="cookieAccepted('declined')" @allow="cookieAccepted('allowed')">
    </cookieLaw>
  </div>
</template>

<script>
export default {
  name: "landing-page",
  components: {},
  metaInfo: {
    // Children can override the title.
    title: "Welcome to Meritios",
    titleTemplate: "%s",
    // Define meta tags here.
    meta: [{ name: "title", content: "Welcome to Meritios" }],
  },
  data() {
    return {
      show_dropdown_1: false,
      show_dropdown_2: false,
      show_dropdown_3: false,
      show_cookie_law: false,
      investor: {
        mail_from: "",
        mail_body: "",
      },
      contact: {
        company: "",
        phone: "",
        mail_from: "",
        mail_body: "Please contact me",
      },
      is_contact_loading: false,
      type: "vertical",
      currentIndex: 1,
      vs: null,
      active_slide: 0,
      selected_slide: {
        title: "Meritios",
        content: "The road from student <br> to professional",
      },
      slide_content: [
        {
          title: "Meritios",
          content: "The road from student <br> to professional",
        },
        {
          title: "Meritios",
          content: "The easiest way for schools <br> to manage their students",
        },
        {
          title: "Meritios",
          content: "Simplest mean for companies <br> to get LIA candidates",
        },
      ],
      selected_crm_route: {
        label: "Heatmaps",
        icon: "crm-home.svg",
        icon_active: "home-active.svg",
        enabled: true,
        img_width: "20px",
        preview: require("@/assets/landing/school/heatmap.png"),
      },
      crm_routes: [
        {
          label: "Heatmaps",
          icon: "crm-home.svg",
          icon_active: "home-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/heatmap.png"),
          active: true,
        },
        {
          label: "Task",
          icon: "task.svg",
          icon_active: "task-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/task.png"),
          active: false,
        },
        {
          label: "Instructor",
          icon_active: "instructor-active.svg",
          icon: "instructor.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/instructor.png"),
          active: false,
        },
        {
          label: "Accounts",
          icon_active: "customers-active.svg",
          icon: "customers.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/account.png"),
          active: false,
        },
        {
          label: "School",
          icon_active: "organization-active.svg",
          icon: "organization.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/school.png"),
          active: false,
        },
        // check
        {
          label: "Resumes",
          icon_active: "resumes-active.svg",
          icon: "resumes.svg",
          enabled: false,
          img_width: "20px",
          preview: null,
          active: false,
        },
        // check
        {
          label: "Students",
          icon_active: "candidate-active.svg",
          icon: "candidate.svg",
          enabled: false,
          img_width: "15px",
          preview: null,
          active: false,
        },
        {
          label: "Reports",
          icon_active: "reports-active.svg",
          icon: "reports.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/report.png"),
          active: false,
        },
        {
          label: "Skills",
          icon_active: "resumes-active.svg",
          icon: "resumes.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/school/skills.png"),
          active: false,
        },
      ],
      selected_students_route: {
        label: "Public Information",
        icon: "public.svg",
        icon_active: "public-active.svg",
        enabled: true,
        img_width: "20px",
        preview: require("@/assets/landing/students/public-info.png"),
        active: false,
      },
      students_routes: [
        {
          label: "Public Information",
          icon: "public.svg",
          icon_active: "public-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/students/public-info.png"),
          active: true,
        },
        {
          label: "Projects",
          icon: "project.svg",
          icon_active: "project-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/students/projects.png"),
          active: false,
        },
        {
          label: "Skills",
          icon_active: "s-skills-active.svg",
          icon: "s-skills.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/students/skills.png"),
          active: false,
        },
        {
          label: "Employments",
          icon_active: "employments-active.svg",
          icon: "employments.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/students/employments.png"),
          active: false,
        },
        {
          label: "Qualifications",
          icon_active: "qualifications-active.svg",
          icon: "qualifications.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/students/qulification.png"),
          active: false,
        },
      ],
      selected_companies_route: {
        label: "Public Information",
        icon: "public.svg",
        icon_active: "public-active.svg",
        enabled: true,
        img_width: "20px",
        preview: require("@/assets/landing/companies/public.png"),
        active: true,
      },
      companies_routes: [
        {
          label: "Public Inforamation",
          icon: "public.svg",
          icon_active: "public-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/companies/public.png"),
          active: true,
        },
        {
          label: "LIA",
          icon: "internship.svg",
          icon_active: "internship-active.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/companies/internships.png"),
          active: false,
        },
        {
          label: "Search",
          icon_active: "s-search-active.svg",
          icon: "s-search.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/companies/search.png"),
          active: false,
        },
        {
          label: "Interns",
          icon_active: "intern-active.svg",
          icon: "intern.svg",
          enabled: true,
          img_width: "20px",
          preview: require("@/assets/landing/companies/intern.png"),
          active: false,
        },
      ],
      active_section: 0,
    };
  },
  mounted() {
    let vm = this;
    vm.startSlide();
    if (!vm.$localStorage.get("cookie:accepted")) {
      vm.show_cookie_law = true;
    }
  },
  methods: {
    cookieAccepted(status) {
      let vm = this;
      vm.$localStorage.set("cookie:accepted", status);
      vm.show_cookie_law = false;
    },
    startSlide() {
      let vm = this;

      setInterval(() => {
        vm.selected_slide = false;
        setTimeout(() => {
          if (vm.active_slide < vm.slide_content.length - 1) {
            vm.active_slide += 1;
          } else {
            vm.active_slide = 0;
          }
          vm.selected_slide = vm.slide_content[vm.active_slide];
        }, 100);
      }, 3000);
    },
    selectStudentRoute(item) {
      let vm = this;
      vm.students_routes.forEach((item) => {
        item.active = false;
      });
      vm.selected_students_route = item;
      vm.selected_students_route.active = true;
    },
    selectCompanyRoutes(item) {
      let vm = this;
      vm.companies_routes.forEach((item) => {
        item.active = false;
      });
      vm.selected_companies_route = item;
      vm.selected_companies_route.active = true;
    },
    selectCrmRoute(item) {
      let vm = this;
      vm.crm_routes.forEach((item) => {
        item.active = false;
      });
      vm.selected_crm_route = item;
      vm.selected_crm_route.active = true;
    },
    handlePostScroll(vertical, horizontal, nativeEvent) {
      var sections = document.querySelectorAll(".screen-section");
      let vm = this;
      sections.forEach((item, index) => {
        vm.checkVisible(item, sections, index);
      });
    },
    checkVisible(elm, sections, index) {
      let vm = this;
      var rect = elm.getBoundingClientRect();
      var viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight
      );

      if (rect.bottom < 0) {
        //note
        if (index < 6) {
          elm
            .querySelector(".section_" + parseInt(index + 1) + "_bg")
            .classList.remove("active");
          sections[parseInt(index + 1)]
            .querySelector(".section_" + parseInt(index + 2) + "_bg")
            .classList.add("active");
          vm.active_section = index + 2;
        }
      } else {
        if (!(rect.bottom < 0 || rect.top - viewHeight >= -500)) {
          if (index < 6) {
            elm
              .querySelector(".section_" + parseInt(index + 1) + "_bg")
              .classList.add("active");
            sections[parseInt(index + 1)]
              .querySelector(".section_" + parseInt(index + 2) + "_bg")
              .classList.remove("active");
            vm.active_section = index + 1;
          }
        }
      }

      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    nextPage(el_class) {
      let vm = this;
      vm.show_dropdown_1 = false;
      vm.show_dropdown_2 = false;
      vm.show_dropdown_3 = false;
      vm.$refs["vs"].scrollIntoView(el_class, 1000);
    },
    goConsultantNetwork() {
      let vm = this;
      vm.$router.push({ name: "signup", query: { type: "consultant" } });
    },
    viewService(key) {
      let vm = this;
      vm.active_slide = key;
    },
    goto(path) {
      this.$router.push({ path: path });
    },
    signUp() {
      this.$router.push({ name: "signup" });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    openForum() {
      window.open("https://forum.meritios.com");
    },
    sendContactMail() {
      let vm = this;
      const rules = {
        company: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Company can not be empty";
          },
        },
        phone: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Phone can not be empty";
          },
        },
        mail_from: {
          run: (value) => {
            if (value) {
              return false;
            } else {
              return "Please add your email";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.contact, rules)) {
        vm.is_contact_loading = true;
        this.contact.mail_body +=
          "\n\n sent from " +
          this.contact.mail_from +
          "\n\n Company: " +
          this.contact.company +
          "\n\n Phone: " +
          this.contact.phone;

        this.$store
          .dispatch("SEND_CONTACT_MAIL", this.contact)
          .then((responce) => {
            vm.is_contact_loading = false;
            vm.contact = {
              company: "",
              phone: "",
              mail_from: "",
              mail_body: "Please contact me",
            };
          })
          .catch((error) => { });
        this.showContact = false;
      }
    },
    sendInvestorMail() {
      this.investor.mail_body += "\n\n sent from " + this.investor.mail_from;
      this.$store.dispatch("SEND_INVESTOR_MAIL", this.investor);
      this.showInvestor = false;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
  transition: 300ms ease-in-out;
}

.btn-gotit {
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 300;
  width: 135px;
  height: 52px;
  background: #1ba5a4;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 300px) and (max-width: 800px) {
    width: 105px;
    height: 39px;
  }
}

.btn-dropdown {
  display: flex;
  align-items: center;

  img {
    width: 12px;
  }
}
</style>

<style lang="scss" scoped>
.dropdown-widget {
  position: absolute;
  z-index: 999;
  background: #fff;
  right: -213px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 0px 10px #555454;
  top: -42px;

  @media (min-width: 300px) and (max-width: 800px) {
    top: 20px;
    right: 0px;
  }

  .dropdown-item {
    font-size: 14px;
    padding: 10px 10px;
    text-decoration: none;
    margin-right: 60px;

    &.active {
      color: #1ba5a4;
    }
  }
}

.landing-widget {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #000;

  .screen-section {
    height: 105vh;
    width: 100%;

    &.section_1 {
      position: relative;
      overflow: hidden;

      .section_1_bg {
        background: #000 url("~@/assets/landing/section-one-bj.png") no-repeat center;
        background-size: cover;
        background-origin: initial;
        background-position-y: -34px;
        background-position-x: -6px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 100vh;
        z-index: 10;
        transition: 200ms ease-in-out;

        @media (min-width: 300px) and (max-width: 800px) {
          background-size: cover;
          background-position: right;
          background-position-y: 5px;
        }

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 10;
          transition: 200ms ease-in-out;
        }
      }

      .colrner-1-object {
        position: absolute;
        top: -89px;
        left: -77px;
        height: 60%;
        width: 29%;
        border-radius: 50%;
        background: linear-gradient(180deg, #0884af 0%, #1ba5a400 100%);
        transform: rotate(-17.38deg);
        filter: blur(40px);
        z-index: 55;
      }

      .colrner-2-object {
        position: absolute;
        bottom: -109px;
        right: -77px;
        height: 60%;
        width: 29%;
        border-radius: 50%;
        background: linear-gradient(180deg, #0884af 0%, #1ba5a400 100%);
        transform: rotate(104.38deg);
        filter: blur(40px);
        z-index: 55;
      }

      .blue-pill-object {
        position: absolute;
        top: 40%;
        left: 0px;
        z-index: 55;
      }

      .toroid-yellow-object {
        position: absolute;
        bottom: 30px;
        right: 10px;
        z-index: 55;

        @media (min-width: 300px) and (max-width: 800px) {
          top: 290px;
        }

        img {
          @media (min-width: 300px) and (max-width: 800px) {
            width: 70px;
          }
        }
      }

      .navigation-widget {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 60px;
        left: 130px;
        right: 130px;
        z-index: 999999;

        @media (min-width: 300px) and (max-width: 800px) {
          top: 18px;
          left: 20px;
          right: 20px;
        }

        .nav-brand {
          display: flex;
          align-items: center;

          img {
            width: 200px;

            @media (min-width: 300px) and (max-width: 800px) {
              width: 130px;
            }
          }
        }

        .nav-options {
          display: flex;
          align-items: center;
          justify-content: center;

          .sign_in_btn {
            outline: none;
            color: #fff;
            width: 90px;
            height: 35px;
            font-family: "Nunito", sans-serif;
            font-size: 18px;
            font-weight: 300;
            background: transparent;

            @media (min-width: 300px) and (max-width: 800px) {
              width: auto;
              margin-right: 10px;
              font-size: 13px;
            }
          }

          .register_btn {
            font-family: "Nunito", sans-serif;
            font-size: 14px;
            font-weight: 300;
            width: 135px;
            height: 52px;
            background: #1ba5a4;
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;

            @media (min-width: 300px) and (max-width: 800px) {
              width: 105px;
              height: 39px;
            }

            span {
              margin-right: 10px;
              color: #fff;

              @media (min-width: 300px) and (max-width: 800px) {
                font-size: 12px;
              }
            }

            img {
              width: 20px;
            }
          }
        }
      }

      .section-1-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        top: 300px;
        left: 130px;
        right: 130px;
        z-index: 55;

        @media (min-width: 300px) and (max-width: 800px) {
          flex-direction: column-reverse;
          top: 70px;
          left: 0px;
          right: 0px;
        }

        .slide-widget {
          position: relative;
          width: 50%;

          @media (min-width: 300px) and (max-width: 800px) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
          }

          .sphere-object {
            position: absolute;
            top: -115px;

            @media (min-width: 300px) and (max-width: 800px) {
              display: none;
            }
          }

          .slide-content-widget {
            @media (min-width: 300px) and (max-width: 800px) {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }

            h1 {
              font-weight: 800;
              font-size: 92px;
              background: linear-gradient(to right, #1ba5a4 0%, #0884af 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;

              @media (min-width: 300px) and (max-width: 800px) {
                font-size: 23px;
              }
            }

            p {
              font-family: "Nunito", sans-serif;
              font-style: normal;
              font-weight: 300;
              font-size: 36px;
              line-height: 49px;
              color: #ffffff;

              @media (min-width: 300px) and (max-width: 800px) {
                text-align: center;
                font-size: 13px;
                line-height: 19px;
              }
            }

            .slide-dots {
              display: flex;
              margin: 50px 0px;

              @media (min-width: 300px) and (max-width: 800px) {
                margin: 20px 0px;
              }

              .slide-dot {
                height: 8px;
                width: 8px;
                border-radius: 50%;
                background: #707070;
                margin-right: 6px;
                transition: 500ms ease-in-out;

                &.active {
                  width: 40px;
                  background: #fff;
                  border-radius: 5px;
                  transition: 500ms ease-in-out;
                }
              }
            }
          }

          .section-options {
            display: flex;
            align-items: center;

            .btn-get-started {
              height: 60px;
              width: 150px;
              background: radial-gradient(98.25% 119.24% at 6.06% 12.5%,
                  #1ba5a4 0%,
                  #0884af 100%);
              box-shadow: 0px 12px 9px rgba(0, 0, 0, 0.32);
              border-radius: 5px;
              color: #fff;
              margin-right: 10px;

              @media (min-width: 300px) and (max-width: 800px) {
                height: 44px;
                width: 123px;
              }
            }

            .btn-learn-more {
              height: 60px;
              width: 150px;
              background: radial-gradient(76.27% 76.27% at 93.61% 5.4%,
                  rgba(255, 255, 255, 0.700689) 0%,
                  rgba(8, 132, 175, 0.6) 100%);
              border-radius: 5px;
              color: #fff;
              margin-right: 10px;
            }
          }
        }

        .section-1-image-widget {
          position: relative;
          width: 50%;
          height: 391px;

          @media (min-width: 300px) and (max-width: 800px) {
            width: 100%;
            display: flex;
            justify-items: center;
            height: 315px;
          }

          img.student {
            position: absolute;
            top: -230px;
            width: 730px;

            @media (min-width: 300px) and (max-width: 800px) {
              width: 300px;
              left: 14%;
              top: 12px;
            }
          }

          img.orange-box-object {
            position: absolute;
            bottom: -20px;
            width: 80px;

            @media (min-width: 300px) and (max-width: 800px) {
              position: absolute;
              bottom: -79%;
              width: 80px;
            }
          }

          img.toroid-purple {
            position: absolute;
            top: -61px;
            left: 109px;
            width: 82px;

            @media (min-width: 300px) and (max-width: 800px) {
              top: -10px;
              left: 65px;
              width: 77px;
            }
          }
        }
      }
    }

    &.section_2 {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .section_2_bg {
        background: #0884af;
        position: fixed;
        top: 100vh;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 12;
        transition: 200ms ease-in-out;

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 12;
          transition: 200ms ease-in-out;
        }
      }

      .section-content {
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 55;

        .section-title {
          color: #fff;
          font-size: 45px;
          margin-bottom: 94px;
          display: flex;

          b {
            margin: 0px 15px;
          }

          @media (min-width: 300px) and (max-width: 800px) {
            font-size: 27px;
          }
        }

        .crm-summury-widget {
          width: 1200px;
          display: flex;

          @media (min-width: 300px) and (max-width: 800px) {
            flex-direction: column;
            width: 100%;
          }

          .crm-navigation {
            background: linear-gradient(153.11deg,
                #1ba5a4 1.41%,
                #0884af 98.7%);
            border-radius: 10px;
            padding: 15px;
            position: relative;
            height: 410px;

            @media (min-width: 300px) and (max-width: 800px) {
              height: unset;
              margin-bottom: 40px;
              margin-left: 10px;
              margin-right: 10px;
            }

            .toroid-yellow {
              position: absolute;
              left: -160px;
              top: 19%;
              width: 200px;

              @media (min-width: 300px) and (max-width: 800px) {
                display: none;
              }
            }

            ul {
              list-style: none;

              @media (min-width: 300px) and (max-width: 800px) {
                display: flex;
                padding: 0px;
                justify-content: space-between;
              }

              li {
                border-radius: 5px;
                height: 55px;
                width: 300px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                cursor: pointer;

                @media (min-width: 300px) and (max-width: 800px) {
                  width: unset;
                }

                .icon-active {
                  display: none;
                }

                .menu-text {
                  color: #ffffff;
                  margin-left: 10px;
                  margin-top: 6px;

                  @media (min-width: 300px) and (max-width: 800px) {
                    display: none;
                  }
                }

                &.active {
                  background: linear-gradient(90deg,
                      #ffffff 0%,
                      rgba(255, 255, 255, 0.479127) 69.81%,
                      rgba(255, 255, 255, 0) 88.45%);

                  .icon {
                    display: none;
                  }

                  .icon-active {
                    display: block;
                  }

                  .menu-text {
                    color: #1ba5a4;
                  }
                }
              }
            }
          }

          .crm-preview {
            width: calc(100% - 300px);

            @media (min-width: 300px) and (max-width: 800px) {
              width: 100%;
            }

            img {
              width: 100%;
              position: relative;
              top: -25px;
            }
          }
        }
      }
    }

    &.section_3 {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .section_3_bg {
        background: #1ba5a4;
        position: fixed;
        top: 100vh;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 14;
        transition: 200ms ease-in-out;

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 14;
          transition: 200ms ease-in-out;
        }
      }

      .section-content {
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 55;

        .section-title {
          color: #fff;
          font-size: 45px;
          display: flex;

          b {
            margin: 0px 15px;
          }

          @media (min-width: 300px) and (max-width: 800px) {
            font-size: 27px;
          }
        }

        .crm-summury-widget {
          margin-top: 20px;
          width: 885px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          @media (min-width: 300px) and (max-width: 800px) {
            width: 100%;
            margin-bottom: 40px;
            margin-left: 10px;
            margin-right: 10px;
          }

          .crm-navigation {
            background: linear-gradient(90.57deg,
                rgba(255, 255, 255, 0.3) -0.65%,
                rgba(255, 255, 255, 0) 103.77%);
            border-radius: 10px;
            padding: 15px;
            position: relative;
            margin-bottom: 30px;
            width: 100%;

            ul {
              list-style: none;
              display: flex;

              @media (min-width: 300px) and (max-width: 800px) {
                display: flex;
                padding: 0px;
                justify-content: space-between;
              }

              li {
                border-radius: 5px;
                height: 55px;
                width: 400px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                cursor: pointer;

                @media (min-width: 300px) and (max-width: 800px) {
                  width: unset;
                }

                .icon-active {
                  display: none;
                }

                .menu-text {
                  color: #ffffff;
                  margin-left: 10px;
                  margin-top: 6px;

                  @media (min-width: 300px) and (max-width: 800px) {
                    display: none;
                  }
                }

                &.active {
                  background: linear-gradient(90deg,
                      #ffffff 43%,
                      rgba(255, 255, 255, 0.479127) 92.81%,
                      rgba(255, 255, 255, 0) 116.45%);

                  .icon {
                    display: none;
                  }

                  .icon-active {
                    display: block;
                  }

                  .menu-text {
                    color: #1ba5a4;
                  }
                }
              }
            }
          }

          .crm-preview {
            width: 100%;
            position: relative;

            .pill-object {
              position: absolute;
              right: -87px;
              bottom: 29px;
              width: 200px;
              z-index: 4;
            }

            img.preview-image {
              width: 100%;
              position: relative;
              top: -25px;
            }
          }
        }
      }
    }

    &.section_4 {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .section_4_bg {
        background: #676767;
        position: fixed;
        top: 100vh;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 16;
        transition: 200ms ease-in-out;

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 16;
          transition: 200ms ease-in-out;
        }
      }

      .section-content {
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 55;

        .section-title {
          color: #fff;
          font-size: 45px;
          display: flex;

          b {
            margin: 0px 15px;
          }

          @media (min-width: 300px) and (max-width: 800px) {
            font-size: 27px;
          }
        }

        .crm-summury-widget {
          margin-top: 20px;
          width: 885px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          @media (min-width: 300px) and (max-width: 800px) {
            flex-direction: column;
            width: 100%;
          }

          .crm-navigation {
            background: linear-gradient(90.57deg,
                rgba(255, 255, 255, 0.3) -0.65%,
                rgba(255, 255, 255, 0) 103.77%);
            border-radius: 10px;
            padding: 15px;
            position: relative;
            margin-bottom: 30px;
            width: 100%;

            @media (min-width: 300px) and (max-width: 800px) {
              height: unset;
              margin-bottom: 40px;
              margin-left: 10px;
              margin-right: 10px;
            }

            .orange-object {
              position: absolute;
              left: -113px;
              top: -96px;
              width: 150px;
              z-index: 4;

              @media (min-width: 300px) and (max-width: 800px) {
                display: none;
              }
            }

            ul {
              list-style: none;
              display: flex;

              @media (min-width: 300px) and (max-width: 800px) {
                display: flex;
                padding: 0px;
                justify-content: space-between;
              }

              li {
                border-radius: 5px;
                height: 55px;
                width: 400px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                cursor: pointer;

                @media (min-width: 300px) and (max-width: 800px) {
                  width: unset;
                }

                .icon-active {
                  display: none;
                }

                .menu-text {
                  color: #ffffff;
                  margin-left: 10px;
                  margin-top: 6px;

                  @media (min-width: 300px) and (max-width: 800px) {
                    display: none;
                  }
                }

                &.active {
                  background: linear-gradient(90deg,
                      #ffffff 43%,
                      rgba(255, 255, 255, 0.479127) 92.81%,
                      rgba(255, 255, 255, 0) 116.45%);

                  .icon {
                    display: none;
                  }

                  .icon-active {
                    display: block;
                  }

                  .menu-text {
                    color: #1ba5a4;
                  }
                }
              }
            }
          }

          .crm-preview {
            width: 100%;
            position: relative;

            img.preview-image {
              width: 100%;
              position: relative;
              top: -25px;
            }
          }
        }
      }
    }

    &.section_5 {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      .section_5_bg {
        background: linear-gradient(108.13deg, #0884af -0.5%, #1ba5a4 100.64%);
        position: fixed;
        top: 100vh;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 18;
        transition: 200ms ease-in-out;

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 18;
          transition: 200ms ease-in-out;
        }
      }

      .contacts-widget {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 70px;
        z-index: 55;

        .header {
          padding: 30px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          h1 {
            text-align: center;
            color: #fff;
            font-weight: 800;
            font-size: 30px;
            font-weight: 800;

            @media (min-width: 300px) and (max-width: 800px) {
              font-size: 20px;
            }
          }

          h2 {
            font-size: 40px;
            color: #d5d5d5;
            font-weight: 800;
            margin: 20px 0px;
            text-align: center;

            @media (min-width: 300px) and (max-width: 800px) {
              font-size: 23px;
            }
          }

          p {
            font-size: 17px;
            text-align: center;
            color: #d5d5d5;

            @media (min-width: 300px) and (max-width: 800px) {
              font-size: 14px;
            }
          }
        }

        .body {
          display: flex;
          justify-content: center;

          @media (min-width: 300px) and (max-width: 800px) {
            flex-direction: column;
            width: 100%;
            padding-right: 20px;
            padding-left: 20px;
          }

          .form-widget {
            width: 629px;
            display: flex;
            align-items: center;
            flex-direction: column;
            position: relative;

            @media (min-width: 300px) and (max-width: 800px) {
              flex-direction: column;
              width: 100%;
            }

            .cicle-image {
              position: absolute;
              right: -100px;
              top: -93px;
              width: 122px;

              @media (min-width: 300px) and (max-width: 800px) {
                display: none;
              }
            }

            input {
              width: 100%;
              border: 1px solid rgba(255, 255, 255, 0.25);
              box-sizing: border-box;
              border-radius: 4px;
              height: 55px;
              margin-bottom: 20px;
              padding: 0px 15px;
              outline: none;
              background: rgba(255, 255, 255, 0.15);
              border-radius: 10px;
              color: #fff;

              &::placeholder {
                color: rgb(224, 224, 224);
              }
            }

            .btn-submit {
              width: 100%;
              height: 55px;
              background: #0884af;
              border: 1px solid rgba(255, 255, 255, 0.25);
              color: #fff;
              border-radius: 4px;
              font-weight: 800;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .footer-widget {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 89px;
        background: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 17px 0px;
        z-index: 55;

        img {
          width: 150px;
        }

        .btn-back {
          display: block;
          margin: 0 auto;
          width: 100px;
          height: 32px;
          background: #ffffff;
          border-radius: 5px;
          color: #0884af;
          position: absolute;
          top: -49px;
          right: 10px;

          @media (min-width: 300px) and (max-width: 800px) {
            width: 100px;
            height: 32px;
          }

          img {
            margin-left: 10px;
          }
        }
      }
    }

    &.section_6 {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .section_6_bg {
        background: linear-gradient(108.13deg, #0884af -0.5%, #1ba5a4 100.64%);
        position: fixed;
        top: 100vh;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 17;
        transition: 200ms ease-in-out;

        &.active {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 17;
          transition: 200ms ease-in-out;
        }
      }

      .section-content {
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        z-index: 55;

        .section-title {
          color: #fff;
          font-size: 45px;
          margin-bottom: 30px;
        }

        .crm-summury-widget {
          margin-top: 20px;
          width: 885px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;

          .cicle-image {
            position: absolute;
            right: -100px;
            top: -130px;
          }

          .item-body {
            background: rgba(255, 255, 255, 0.15);
            border-radius: 10px;
            padding: 40px 75px;
            padding-top: 80px;
            margin-bottom: 30px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            p {
              color: #fff;
              font-size: 18px;
              position: relative;

              .image-quote {
                position: absolute;
                top: -38px;
                left: -25px;
              }
            }

            .info-content {
              display: flex;
              align-items: center;

              .profile {
                height: 50px;
                width: 50px;
                border-radius: 50%;
                margin-right: 15px;
                border: 1px solid #fff;
              }

              .names {
                color: #fff;
                text-transform: uppercase;
              }
            }
          }
        }
      }
    }

    .section-go-next-widget {
      display: block;
      position: absolute;
      bottom: 90px;
      left: 130px;
      right: 130px;
      z-index: 99;

      @media (min-width: 300px) and (max-width: 800px) {
        bottom: 100px;
        left: 0px;
        right: 0px;
      }

      .how-it-works {
        display: block;
        margin: 0 auto;
        width: 163px;
        height: 55px;
        background: #ffffff;
        border-radius: 5px;
        color: #0884af;

        @media (min-width: 300px) and (max-width: 800px) {
          width: 180px;
          height: 41px;
        }

        img {
          margin-left: 10px;
        }
      }
    }
  }
}</style>



